module.exports = __webpack_public_path__ + "img/time-lesson.500401c5.svg";